import EditorActions from './EditorActions';

export default {
  __init__: [
    'tokenSimulationEditorActions'
  ],
  tokenSimulationEditorActions: [ 'type', EditorActions ]
};